import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { About } from "./pages/About";
import { CurrentListings } from "./pages/CurrentListings";
import { DreamHome } from "./pages/DreamHome";
import { HarbourIsleEast } from "./pages/HarbourIsleEast";
import { HarbourIsleProperties } from "./pages/HarbourIsleProperties";
import { HarbourIsleWest } from "./pages/HarbourIsleWest";
import { Home } from "./pages/Home";
import { MlsListings } from "./pages/MlsListings";
import { OpenHouses } from "./pages/OpenHouses";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfUse } from "./pages/TermsOfUse";
export function App() {
  useEffect(() => {
    document.title = "Teri Britton Real Estate of Florida";
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="28u5xmlt5v3cb">
      <Routes data-id="element-1" data-mp="28tmdqzjya4vn">
        <Route path="/" element={<Home data-id="element-3" data-mp="28sl5t3y8dyi5" />} data-id="element-2" data-mp="28t4lee0esat0" />
        <Route path="/about" element={<About data-id="element-5" data-mp="23vul23bheeqe" />} data-id="element-4" data-mp="28s30zixi6bym" />
        <Route path="/dream-home" element={<DreamHome data-id="element-7" data-mp="23t8g8bfz6dbv" />} data-id="element-6" data-mp="23ujksdh8vp41" />
        <Route path="/mls-listings" element={<MlsListings data-id="element-9" data-mp="3iiwaeb4natww" />} data-id="element-8" data-mp="3ik7gihlkcdr6" />
        <Route path="/harbour-isle-properties" element={<HarbourIsleProperties data-id="element-11" data-mp="3ml1397n9rmih" />} data-id="element-10" data-mp="3ijpe138b53at" />
        <Route path="/harbour-isle-west" element={<HarbourIsleWest data-id="element-13" data-mp="3rc9d24sih9w6" />} data-id="element-12" data-mp="3mjzs7369700r" />
        <Route path="/harbour-isle-east" element={<HarbourIsleEast data-id="element-15" data-mp="3rd189ei755lx" />} data-id="element-14" data-mp="3rbznujfaj6rj" />
        <Route path="/current-listings" element={<CurrentListings data-id="element-17" data-mp="4n4pyuukj8z" />} data-id="element-16" data-mp="5osn3wyp084" />
        <Route path="/open-houses" element={<OpenHouses data-id="element-19" data-mp="2zld43f9knpe6" />} data-id="element-18" data-mp="82kl3wchwbg" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-21" data-mp="2zn6bwxvx8fnr" />} data-id="element-20" data-mp="2zm4xcjfp5b1a" />
        <Route path="/terms-of-use" element={<TermsOfUse data-id="element-23" data-mp="33ngdzzglelxc" />} data-id="element-22" data-mp="33mf1rrnubte1" />
      </Routes>
    </BrowserRouter>;
}